import {addQueryParamsToImageUrl, ImageQueryParams} from 'image-url-utils';
import {ImageMode, imageModeQueryParams, imageModeSizes} from './image-mode';

export const imageDensities = [1, 2];
const imageModeDensities: Partial<Record<ImageMode, number[]>> = {
  full: [0.5, 0.75, 1, 1.25, 1.5, 2],
};

export const buildImageParams = (mode: ImageMode, multiplier = 1): ImageQueryParams => {
  const params: ImageQueryParams = {
    ...imageModeQueryParams[mode],
    format: 'webp',
  };

  if (params.width) {
    params.width = Math.round(params.width * multiplier);
  }

  if (params.height) {
    params.height = Math.round(params.height * multiplier);
  }

  return params;
};

export const buildImageUrl = (source: string, mode: ImageMode, multiplier = 1): string => {
  const params = buildImageParams(mode, multiplier);
  return addQueryParamsToImageUrl(source, params, {replaceExistingSearch: true});
};

export const getImageDensities = (mode: ImageMode): number[] => {
  return imageModeDensities[mode] ?? imageDensities;
};

export const buildSrcSet = (source: string, mode: ImageMode, densities?: number[]): string => {
  const densityList = densities ?? getImageDensities(mode);
  const baseWidth = mode === 'full' ? imageModeQueryParams[mode].width : undefined;

  return densityList
    .map(multiplier => {
      const descriptor = baseWidth
        ? `${Math.round(baseWidth * multiplier)}w`
        : `${multiplier}x`;

      return `${buildImageUrl(source, mode, multiplier)} ${descriptor}`;
    })
    .join(', ');
};

export const getImageSizes = (mode: ImageMode): string => {
  return imageModeSizes[mode] ?? '100vw';
};

export const listPrefetchUrls = (
  source: string,
  modes: ImageMode[],
  densities?: number[]
): string[] => {
  const urls = new Set<string>();

  for (const mode of modes) {
    const densityList = densities ?? getImageDensities(mode);

    for (const multiplier of densityList) {
      urls.add(buildImageUrl(source, mode, multiplier));
    }
  }

  return Array.from(urls);
};
